import {Component, DestroyRef, inject} from '@angular/core';
import {Router} from '@angular/router';
import {EMPTY, catchError, switchMap, timer} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {faWrench} from '@fortawesome/free-solid-svg-icons';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {MaintenanceService} from '../services/maintenance.service';

/** Intervalle de vérification de l'état de maintenance (10 secondes). */
const POLL_INTERVAL_MS = 10_000;

@Component({
    selector: 'app-maintenance',
    imports: [
    FaIconComponent
],
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent {
  faWrench = faWrench;

  private maintenanceService = inject(MaintenanceService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  constructor() {
    // Interroge régulièrement l'état réel de la maintenance : dès que le portail
    // redevient disponible, l'utilisateur est redirigé sans aucune action de sa part.
    timer(0, POLL_INTERVAL_MS).pipe(
      switchMap(() => this.maintenanceService.isEnabled().pipe(
        // Échec de l'appel (backend indisponible pendant la maintenance) :
        // on garde la page et on retentera au prochain cycle, sans débloquer l'accès.
        catchError(() => EMPTY)
      )),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(enabled => {
      if (!enabled) {
        this.router.navigate(['/']);
      }
    });
  }
}
